import React, {Suspense} from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Stream from '../../pages/difacto/streams/Stream';
import StreamsList from '../../pages/difacto/streams/StreamsList';
import NewStream from "../../pages/difacto/streams/NewStream";
import EditStream from "../../pages/difacto/streams/EditStream";

function Streams(props) {
  const { path } = useRouteMatch();
  const { t } = useTranslation();

	return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route exact path={`${path}`} component={StreamsList}/>
        <Route exact path={`${path}/new`} component={NewStream}/>
        <Route path={`${path}/:streamId/edit`} component={EditStream}/>
        <Route path={`${path}/:streamId`} component={Stream}/>
      </Switch>
    </Suspense>
	)
}

export default Streams
